import { clerkAuthHeaders } from './clerkApiAuth';
import { ResourceOrder, ResourceOrderWrite } from '../types/resourceOrder';

const API_BASE_URL = '/api';

async function errorMessage(response: Response, fallback: string): Promise<string> {
  try {
    const body = await response.json();
    if (typeof body?.error === 'string' && body.error.trim()) return body.error;
  } catch {
    // The body was not JSON.
  }
  return fallback;
}

export const resourceOrderAPI = {
  async submitOrder(input: ResourceOrderWrite): Promise<{ id: string }> {
    const response = await fetch(`${API_BASE_URL}/resource-orders`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Failed to submit order'));
    return response.json();
  },

  async fetchOrders(): Promise<ResourceOrder[]> {
    const response = await fetch(`${API_BASE_URL}/resource-orders`, {
      headers: await clerkAuthHeaders({ json: false }),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Failed to load orders'));
    return response.json();
  },

  async fetchOrder(id: string): Promise<ResourceOrder> {
    const response = await fetch(`${API_BASE_URL}/resource-orders/${encodeURIComponent(id)}`, {
      headers: await clerkAuthHeaders({ json: false }),
    });
    if (!response.ok) throw new Error(await errorMessage(response, 'Order not found'));
    return response.json();
  },
};
